"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
function module({ imports = [], providers: allProviders = [], exports = [], }) {
    return (target) => {
        const providers = allProviders.filter((provider) => !provider.isGlobal);
        const globalProviders = allProviders.filter((provider) => !!provider.isGlobal);
        const metadata = {
            id: new Date().getTime(),
            isModule: true,
            isBinded: false,
            container: new utils_1.ModuleContainer(),
            imports,
            providers,
            globalProviders,
            exports,
        };
        for (const key in metadata) {
            if (metadata.hasOwnProperty(key)) {
                Reflect.defineMetadata(key, metadata[key], target.prototype);
            }
        }
    };
}
exports.default = module;
